import { useState } from "react";
import { Download, FileText, Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useEquipStationExport } from "@/lib/use-equip-station-export";
import { ExportDialog } from "./ExportDialog";

interface ExportButtonProps {
  scanId?: string;
  ownership?: string;
  classification?: string;
  collectionId?: string;
}

export function ExportButton({
  scanId,
  ownership,
  classification,
  collectionId,
}: ExportButtonProps) {
  const [open, setOpen] = useState(false);
  const { exportToEquip, isExporting } = useEquipStationExport(collectionId);

  const dialog = (
    <ExportDialog
      open={open}
      onOpenChange={setOpen}
      defaultScanId={scanId}
      defaultOwnership={ownership}
      defaultClassification={classification}
      collectionId={collectionId}
    />
  );

  // Outside a collection (e.g. scan results) there's no station data to export,
  // so keep the original single button that opens the data-export dialog.
  if (!collectionId) {
    return (
      <>
        <Button variant="outline" size="sm" onClick={() => setOpen(true)}>
          <Download className="h-4 w-4 mr-1.5" />
          Export
        </Button>
        {dialog}
      </>
    );
  }

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="sm">
            <Download className="h-4 w-4 mr-1.5" />
            Export
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
          <DropdownMenuItem onClick={() => setOpen(true)}>
            <FileText className="size-4" />
            Export data…
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => void exportToEquip()}
            disabled={isExporting}
          >
            <Upload className="size-4" />
            Export to Equip dashboard
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      {dialog}
    </>
  );
}
